import React from 'react';

const FooterSvg = () => (
  <div className='footerSvg'>
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'>
      <path
        fill='#a2d9ff'
        fillOpacity='1'
        d='M0,320L120,298.7C240,277,480,235,720,213.3C960,192,1200,192,1320,192L1440,192L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z'
      />
    </svg>
  </div>
);

export default FooterSvg;
